import { RouteRecordRaw } from 'vue-router';
import { Layout } from '@/router/constant';
import { TableOutlined } from '@vicons/antd';
import { renderIcon } from '@/utils/index';

const routeName = 'material';

/**
 * @param name 路由名称, 必须设置,且不能重名
 * @param meta 路由元信息（路由附带扩展信息）
 * @param redirect 重定向地址, 访问这个路由时,自定进行重定向
 * @param meta.disabled 禁用整个菜单
 * @param meta.title 菜单名称
 * @param meta.icon 菜单图标
 * @param meta.keepAlive 缓存该路由
 * @param meta.sort 排序越小越排前
 * */
const routes: Array<RouteRecordRaw> = [
  {
    path: '/material',
    name: 'material',
    redirect: 'type',
    component: Layout,
    meta: {
      title: '素材管理',
      icon: renderIcon(TableOutlined),
      permissions: ['material'],
      sort: 2,
    },
    children: [
      {
        path: 'type',
        name: `${routeName}_type`,
        meta: { title: '分类管理', permissions: ['material_type'], },
        component: () => import('@/views/material/type/index.vue'),
      },
      {
        path: 'scene',
        name: `${routeName}_scene`,
        meta: { title: '背景', permissions: ['material_bg'], },
        component: () => import('@/views/material/scene/index.vue'),
      },
      {
        path: 'sticker',
        name: `${routeName}_sticker`,
        meta: { title: '贴纸' },
        component: () => import('@/views/material/sticker/index.vue'),
      },
      {
        path: 'prop',
        name: `${routeName}_prop`,
        meta: { title: '道具', permissions: ['material_prop'], },
        component: () => import('@/views/material/prop/index.vue'),
      },
      {
        path: 'frame',
        name: `${routeName}_frame`,
        meta: { title: '道具边框' },
        component: () => import('@/views/material/frame/index.vue'),
      },
      {
        path: 'role',
        name: `${routeName}_role`,
        meta: { title: '角色', permissions: ['material_role'], },
        component: () => import('@/views/material/role/index.vue'),
      },
      {
        path: 'aiRole',
        name: `${routeName}_airole`,
        meta: { title: 'ai角色关联提示词' },
        component: () => import('@/views/material/ai-role/index.vue'),
      },
      {
        path: 'timbre',
        name: `${routeName}_timbre`,
        meta: { title: '音色' },
        component: () => import('@/views/material/timbre/index.vue'),
      },
      {
        path: 'videoTimbre',
        name: `${routeName}_videoTimbre`,
        meta: { title: '克隆音色' },
        component: () => import('@/views/material/videoTimbre/index.vue'),
      },
      {
        path: 'template',
        name: `${routeName}_template`,
        meta: { title: '模板' },
        component: () => import('@/views/material/template/index.vue'),
      },
      {
        path: 'acoustics',
        name: `${routeName}_acoustics`,
        meta: { title: '音效' },
        component: () => import('@/views/material/acoustics/index.vue'),
      },
      {
        path: 'font',
        name: `${routeName}_font`,
        meta: { title: '字体' },
        component: () => import('@/views/material/font/index.vue'),
      },
      {
        path: 'sutitles',
        name: `${routeName}sutitles`,
        meta: { title: '字幕样式' },
        component: () => import('@/views/material/sutitles/index.vue'),
        // component: () => import('@/views/material/font/index.vue'),
      },
    ],
  },
];

export default routes;
